import type { ReactElement, ReactEventHandler, SyntheticEvent } from 'react';

import { useTheme } from '@emotion/react';
import { isNil } from 'ramda';

import * as styles from './table.styles';

type Props = {
  children: ReactElement | ReactElement[];
  className?: string;
  striped?: boolean;
  onClick?: (event?: SyntheticEvent<HTMLTableRowElement>) => void;
};

export const TableRow = ({ children, className, striped = false, onClick }: Props) => {
  const theme = useTheme();
  const handleClick: ReactEventHandler<HTMLTableRowElement> = (event) => {
    !isNil(onClick) && onClick(event);
  };

  return (
    <tr
      className={className}
      css={[styles.tableRow, striped && styles.striped(theme), onClick && styles.clickable(theme)]}
      data-testid="table-row"
      role="row"
      onClick={handleClick}>
      {children}
    </tr>
  );
};
